window.addEventListener('load', () => {
  document.body.classList.add('-show')
  console.log('loaded')

  const initLoading = document.getElementById('init-loading')
  if (initLoading) {
    initLoading.style.display = 'none';
  }
});
